/**
 * Glossary: one letter visible at a time, with a mobile dropdown.
 */
const glossaries = document.querySelectorAll('.glossary');

if (glossaries.length) {
	const letterFromHash = () => {
		const hash = location.hash.slice(1).toLowerCase();
		if (/^[a-z]$/.test(hash)) {
			return hash;
		}

		return hash.match(/-([a-z])$/)?.[1] ?? '';
	};

	const setOpen = (nav, open) => {
		nav?.classList.toggle('is-open', open);
		nav?.querySelector('.glossary__toggle')?.setAttribute('aria-expanded', String(open));
	};

	const activate = (glossary, id) => {
		const panel = id && glossary.querySelector(`.glossary__section#${CSS.escape(id)}`);
		if (!panel) {
			return false;
		}

		glossary.querySelectorAll('.glossary__section').forEach((section) => {
			const on = section === panel;
			section.classList.toggle('is-active', on);
			section.toggleAttribute('hidden', !on);
		});

		let label = '';
		glossary.querySelectorAll('.glossary__letter').forEach((tab) => {
			const on = tab.getAttribute('aria-controls') === id;
			tab.classList.toggle('is-active', on);
			tab.setAttribute('aria-selected', String(on));
			if (on) {
				label = tab.textContent.trim();
			}
		});

		const value = glossary.querySelector('.glossary__toggle-value');
		if (value && label) {
			value.textContent = label;
		}

		return true;
	};

	glossaries.forEach((glossary) => {
		const nav = glossary.querySelector('.glossary__nav');
		const hash = letterFromHash();
		if (hash) {
			activate(glossary, hash);
		}

		nav?.querySelector('.glossary__toggle')?.addEventListener('click', () => {
			setOpen(nav, !nav.classList.contains('is-open'));
		});

		nav?.addEventListener('click', (event) => {
			const tab = event.target.closest('.glossary__letter');
			if (!tab || !nav.contains(tab)) {
				return;
			}

			event.preventDefault();
			const id = tab.getAttribute('aria-controls');
			if (activate(glossary, id)) {
				history.replaceState(null, '', `#${id}`);
				setOpen(nav, false);
			}
		});
	});

	document.addEventListener('click', (event) => {
		document.querySelectorAll('.glossary__nav.is-open').forEach((nav) => {
			if (!nav.contains(event.target)) {
				setOpen(nav, false);
			}
		});
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			document.querySelectorAll('.glossary__nav.is-open').forEach((nav) => setOpen(nav, false));
		}
	});
}
